var _g, _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 180,
    viewBox: "0 0 80 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 18,
    width: 8,
    height: 140,
    fill: "#F64A00"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 49,
    width: 80,
    height: 80,
    fill: "#F64A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5869 82.1003C40.2615 82.1003 40.8079 81.5535 40.8079 80.8793C40.8079 80.205 40.2615 79.6583 39.5869 79.6583C34.1925 79.6583 29.8193 84.0314 29.8193 89.4262C29.8193 94.8207 34.1925 99.1938 39.5869 99.1938C44.9817 99.1938 49.3548 94.8207 49.3548 89.4262C49.3548 88.7516 48.8081 88.2052 48.1338 88.2052C47.4596 88.2052 46.9128 88.7516 46.9128 89.4262C46.9128 93.4721 43.6332 96.7522 39.5869 96.7522C35.541 96.7522 32.2609 93.4721 32.2609 89.4262C32.2609 85.3799 35.541 82.1003 39.5869 82.1003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8815 82.1743C62.6695 81.5337 61.9784 81.1863 61.3374 81.3983C60.7114 81.6055 60.3629 82.2719 60.5495 82.9043C64.2009 94.5319 57.7351 106.918 46.1074 110.569C34.4801 114.221 22.0941 107.755 18.4427 96.1273C14.7909 84.4996 21.2571 72.1136 32.8844 68.4622C37.1887 67.1107 41.8034 67.1107 46.1074 68.4622C46.7536 68.657 47.4353 68.2913 47.6302 67.6451C47.822 67.0086 47.4701 66.3358 46.8377 66.1301C33.9266 62.0794 20.176 69.2621 16.1252 82.1736C12.0744 95.0847 19.2575 108.835 32.1686 112.886C45.0801 116.937 58.8304 109.754 62.8812 96.8427C64.3793 92.0679 64.3793 86.9491 62.8815 82.1743Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.911 73.7232C41.9174 73.028 41.3833 72.4468 40.69 72.3948C40.3254 72.3638 39.9604 72.3328 39.5861 72.3328C30.1454 72.3328 22.4922 79.9859 22.4922 89.4266C22.4922 98.867 30.1454 106.52 39.5861 106.52C49.0264 106.52 56.6796 98.867 56.6796 89.4266C56.6796 88.985 56.6527 88.5437 56.5984 88.1054C56.5008 87.4353 55.8786 86.9712 55.2084 87.0688C54.5383 87.166 54.0742 87.7887 54.1714 88.4588C54.1751 88.4843 54.1796 88.5093 54.1849 88.5347C54.2114 88.8306 54.2376 89.1237 54.2376 89.4259C54.238 97.5181 47.6783 104.078 39.5864 104.079C31.4942 104.079 24.9345 97.5189 24.9342 89.427C24.9338 81.3352 31.4931 74.7751 39.5853 74.7747H39.5857C39.8886 74.7747 40.1822 74.8009 40.4772 74.8271L40.7061 74.8462C41.3441 74.8735 41.8833 74.3783 41.9103 73.7404C41.9106 73.7344 41.9106 73.7288 41.911 73.7232Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9104 75.9953V80.3737L38.7214 88.5627C38.2363 89.0313 38.2229 89.8043 38.6915 90.2893C39.16 90.7743 39.933 90.7878 40.4181 90.3192C40.4281 90.3095 40.4382 90.2994 40.448 90.2893L48.637 82.1003H53.0154C53.3392 82.1003 53.6496 81.9716 53.8789 81.7424L61.2045 74.4164C61.6813 73.9396 61.6813 73.1666 61.2045 72.6898C60.9756 72.461 60.6652 72.3323 60.3413 72.3323H56.6784V68.6693C56.6784 67.9951 56.1316 67.4484 55.457 67.4487C55.1335 67.4487 54.8231 67.5774 54.5943 67.8062L47.2683 75.1322C47.0391 75.3611 46.9104 75.6714 46.9104 75.9953ZM49.3524 76.5009L54.2364 71.6169V73.5533C54.2364 74.2276 54.7831 74.7743 55.4574 74.7743H57.3938L52.5098 79.6583H49.3524V76.5009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1688",
    x: 20,
    y: 0,
    width: 48,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.0627451 0 0 0 0 0.0627451 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1688",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInCircle);
export default __webpack_public_path__ + "static/media/arrow_in_circle.bc3cb421a0b6a8bfcb1cfd8a78ade231.svg";
export { ForwardRef as ReactComponent };